<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    selectedLayout: {
      type: String,
      required: true,
      default: 'grid-3-columns'
    }
  });


  const emit = defineEmits(['update:layout']);
</script>

<template>
  <div class="layout-controls">
    <div
      class="grid-colours-1"
      :class="{ 'selected': props.selectedLayout === 'grid-3-columns' }"
      @click="emit('update:layout', 'grid-3-columns')">
      <svg width="16" height="16" viewBox="0 0 16 16"
           fill="none">
        <rect width="6" height="6" rx="2" fill="#999999" />
        <rect x="10" width="6" height="6" rx="2" fill="#999999" />
        <rect y="10" width="6" height="6" rx="2" fill="#999999" />
        <rect x="10" y="10" width="6" height="6" rx="2" fill="#999999" />
      </svg>
    </div>
    <div
      class="grid-colours-2"
      :class="{ 'selected': props.selectedLayout === 'grid-1-column' }"
      @click="emit('update:layout', 'grid-1-column')">
      <svg width="16" height="16" viewBox="0 0 16 16"
           fill="none">
        <rect width="16" height="1" fill="#999999" />
        <rect y="5" width="16" height="1" fill="#999999" />
        <rect y="10" width="16" height="1" fill="#999999" />
        <rect y="15" width="16" height="1" fill="#999999" />
      </svg>
    </div>
  </div>
</template>

<style scoped>
  .layout-controls {
    .grid-colours-1, .grid-colours-2 {
      cursor: pointer;
      &.selected {
        background-color: #333;
        svg rect {
          fill: white;
        }
      }
    }
  }
</style>
